import { render, staticRenderFns } from "./ModificacionCanalVenta.vue?vue&type=template&id=0d00279a"
import script from "./ModificacionCanalVenta.vue?vue&type=script&lang=js"
export * from "./ModificacionCanalVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports